var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCallMessage && _vm.conversationType === _vm.TYPES.CONV_GROUP)?_c('div',{class:{ 'blink-text': _vm.isBlink }},[_vm._v(" "+_vm._s(_vm.custom)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }